import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  COMPANIES_FEATURE_KEY,
  State,
  companiesAdapter,
} from './companies.reducer';

export const getCompaniesState =
  createFeatureSelector<State>(COMPANIES_FEATURE_KEY);

const { selectAll, selectEntities } = companiesAdapter.getSelectors();

export const getCompaniesLoaded = createSelector(
  getCompaniesState,
  (state: State) => state.loaded,
);

export const getCompaniesError = createSelector(
  getCompaniesState,
  (state: State) => state.error,
);

export const getAllCompanies = createSelector(
  getCompaniesState,
  (state: State) => selectAll(state),
);

export const getCompaniesEntities = createSelector(
  getCompaniesState,
  (state: State) => selectEntities(state),
);

export const getSelectedId = createSelector(
  getCompaniesState,
  (state: State) => state.selectedId,
);

export const getSelected = createSelector(
  getCompaniesEntities,
  getSelectedId,
  (entities, selectedId) =>
    selectedId != null ? entities[selectedId] : undefined,
);
